import {
  Box,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { commonCss } from "../../../CssStyle/commonCss";
import { Done, TaskAlt } from "@mui/icons-material";
// import aboutUsBg from "../../../Images/aboutUsBg.jpg";
// import saleforce from "../../../Images/Saleforce/saleforce.jpg";

const Saleforce = () => {
  return (
    <Grid2 container>
      <Grid2 container size={12} justifyContent={"center"}>
        <Grid2
          container
          size={12}
          sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            alignItems={"center"}
            mt={{ xs: "30%", sm: "20%", md: "15%", lg: "13%", xl: "8%" }}
            sx={{ p: "1rem", maxWidth: { xs: "auto", xl: "2000px" } }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontWeight: 600,
                lineHeight: "normal",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Saleforce Cloud
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                mb: "1rem",
                textAlign: "center",
                color: commonCss.darkGray,
              }}
            >
              We help businesses implement and customize Salesforce to fit their
              unique needs. Our team ensures smooth integration with your
              existing systems and ongoing support. From setup to training, we
              guide you every step of the way. We also offer expert analytics,
              reporting, and marketing automation solutions. With us, you’ll get
              the most out of your Salesforce investment.
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 11, xl: 10 }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <Box
                component={"img"}
                src={"/Images/Saleforce/saleforce.jpg"}
                alt="Saleforce"
                sx={{
                  borderRadius: "15px",
                  width: "100%",
                  height: { xs: "50vh", md: "70vh" },
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            spacing={{ xs: "1rem", md: "2rem" }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Salesforce Implementation
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Implementing Salesforce is the first step to transforming
                    your customer experience and sales performance. We'll work
                    with you to define your business objectives, configure
                    Salesforce to meet your unique needs, and deploy the
                    solution quickly and efficiently. Our implementation
                    services ensure a seamless transition from your existing
                    systems to Salesforce.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Salesforce Customization
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Every business is unique, and so are your needs. Our
                    Salesforce customization services allow you to tailor
                    Salesforce to your exact specifications. Whether it’s custom
                    fields, workflows, dashboards, or more, we ensure your
                    Salesforce platform is optimized to help you achieve your
                    goals with efficiency and precision.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Salesforce Integration
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Maximize your Salesforce investment by integrating it with
                    other critical business applications. We specialize in
                    connecting Salesforce with ERP systems, marketing platforms,
                    third-party tools, and more. Our integration services ensure
                    data flows smoothly between systems, enabling streamlined
                    operations and improved decision-making.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Salesforce Support and Maintenance
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Your Salesforce journey doesn’t end after implementation.
                    Our support and maintenance services provide you with
                    ongoing assistance, ensuring your platform stays updated and
                    runs smoothly. From troubleshooting issues to adding new
                    features, we offer continuous support to keep your business
                    running at its best.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Salesforce Training
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Equip your team with the skills they need to leverage
                    Salesforce effectively. Our training programs are designed
                    to provide your staff with the knowledge and confidence they
                    need to use Salesforce’s powerful features. Whether you need
                    beginner or advanced training, we’ve got you covered.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Salesforce Analytics and Reporting
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Gain deep insights into your business with Salesforce’s
                    powerful analytics tools. We help you set up custom reports
                    and dashboards to track KPIs, monitor performance, and make
                    data-driven decisions. Our experts guide you through the
                    process to ensure you can easily access actionable insights.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Salesforce Marketing Cloud
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Drive personalized marketing campaigns with Salesforce
                    Marketing Cloud. Our team helps you implement and optimize
                    marketing automation, email campaigns, social media
                    strategies, and more, all within Salesforce. Improve
                    engagement, retention, and customer loyalty with data-driven
                    marketing solutions.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default Saleforce;
